import React from 'react';
import { motion } from 'framer-motion';
export function ModulesSection() {
  const modules = [{
    num: '01',
    title: 'El Fin de la Hoja en Blanco',
    desc: 'Reprograma tu mentalidad de "creador" a "Director Creativo". La base de todo lo demás.',
    tag: 'Mentalidad'
  }, {
    num: '02',
    title: 'Tu Arsenal Digital',
    desc: 'ChatGPT + Claude + Canva configurados y conectados en 30 minutos. Solo versiones gratuitas.',
    tag: 'Setup'
  }, {
    num: '03',
    title: 'El Método R.I.C.E.',
    desc: 'La fórmula que hace que la IA deje de sonar como robot y empiece a escribir con tu voz.',
    tag: '⭐ Core'
  }, {
    num: '04',
    title: 'La Fábrica de Ideas',
    desc: '30 conceptos virales en menos de 10 minutos. La Matriz de Contenido Infinito incluida.',
    tag: 'Producción'
  }, {
    num: '05',
    title: 'Escritura con Alma',
    desc: 'Guiones y copies persuasivos con tu propia voz. Técnica de Muestreo de Estilo incluida.',
    tag: 'Copywriting'
  }, {
    num: '06',
    title: 'Magia Visual Automatizada',
    desc: 'Diseño de imágenes y videos de alto impacto. Sistema de Creación en Lote en Canva.',
    tag: 'Diseño'
  }, {
    num: '07',
    title: 'Multiplicación Omnicanal',
    desc: 'Un contenido → TikTok, Instagram, LinkedIn y YouTube en minutos.',
    tag: 'Distribución'
  }, {
    num: '08',
    title: 'Mentalidad de Actualización',
    desc: 'Cómo mantenerte a la vanguardia sin importar qué nueva herramienta de IA salga mañana.',
    tag: 'Futuro'
  }];
  return <section className="py-28 px-6 bg-dark" data-id="element-195">
      <div className="max-w-[800px] mx-auto" data-id="element-196">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="text-center mb-[60px]" data-id="element-197">
          <span className="inline-block text-orange text-xs font-bold tracking-[2px] uppercase mb-4" data-id="element-198">
            El Contenido
          </span>
          <h2 className="text-[clamp(28px,4vw,48px)] font-black mb-4 text-white" data-id="element-199">
            8 Módulos. Un sistema completo.
          </h2>
          <p className="text-lg text-[#AAAAAA] mt-4" data-id="element-200">
            Todo lo que necesitas para tener tu fábrica funcionando este fin de
            semana.
          </p>
        </motion.div>

        <div className="flex flex-col gap-4" data-id="element-201">
          {modules.map((mod, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          delay: i * 0.05
        }} className="bg-cardBg border border-border rounded-2xl p-6 flex flex-col sm:flex-row items-start gap-5 transition-all duration-300 hover:border-[rgba(255,107,0,0.4)] hover:translate-x-1 cursor-pointer" data-id="element-202">
              <div className="bg-gradient-to-br from-orange to-[#FF8C00] text-white w-11 h-11 rounded-xl flex items-center justify-center font-black text-base shrink-0" data-id="element-203">
                {mod.num}
              </div>
              <div className="flex-1" data-id="element-204">
                <h3 className="text-[18px] font-bold mb-1.5 text-white" data-id="element-205">
                  {mod.title}
                </h3>
                <p className="text-[14px] text-[#888] leading-[1.6]" data-id="element-206">
                  {mod.desc}
                </p>
              </div>
              <span className="sm:ml-auto mt-2 sm:mt-0 bg-[rgba(255,107,0,0.1)] border border-[rgba(255,107,0,0.3)] text-orange px-3 py-1 rounded-full text-[12px] font-semibold whitespace-nowrap shrink-0" data-id="element-207">
                {mod.tag}
              </span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}